var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/yes/Informa\xC3\xA7\xC3\xA3o",
    clipPath: "url(#clip0_26413_30308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.36371 13.4242C10.7109 13.4242 13.4243 10.7108 13.4243 7.36358C13.4243 4.0164 10.7109 1.30298 7.36371 1.30298C4.01653 1.30298 1.3031 4.0164 1.3031 7.36358C1.3031 10.7108 4.01653 13.4242 7.36371 13.4242Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.36365 4.93921V7.36345",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.36365 9.78784H7.37001",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26413_30308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5455,
    height: 23.5455,
    fill: "white",
    transform: "translate(0.0909424 0.0908203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon-information.173edfa427217b637855ee505b138530.svg";
export { ForwardRef as ReactComponent };